module.exports = __webpack_public_path__ + "img/bg-robert@2x.06c1c3dc.jpg";